import React, { MouseEventHandler, useState } from 'react'

import { Text } from '../Text'
import { Avatar } from '../Avatar'
import { Logo } from '../Logo'
import { Button } from '../Button'
import { Link } from '../Link'

import {
  IconChevronLeft,
  IconChevronRight,
  IconMenu
} from '@paro.io/base-icons'
import classNames from 'classnames'

interface SidebarProps {
  fixed?: boolean
  sticky?: boolean
  isOpen?: boolean
  badge: string
  SidenavWidth?: string
  SidenavClassNames?: string
  HandleisOpen?: (e?: React.MouseEvent<HTMLElement>) => void
  className?: string
  userInfo: any
  paths: {
    route: string
    target?: string
    name: string
    id?: string
    selected?: boolean
    icon?: React.ReactNode
    tag?: React.ReactNode
    onClick?: MouseEventHandler<HTMLDivElement>
    className?: string
  }[]
}

export const Sidenav = ({
  paths,
  isOpen = true,
  fixed = false,
  sticky = false,
  badge,
  SidenavWidth = 'md:w-1/4',
  HandleisOpen,
  SidenavClassNames,
  userInfo
}: SidebarProps) => {
  const [menuIsOpen, setMenuOpen] = useState(false)
  const toggleMenu = () => {
    setMenuOpen(!menuIsOpen)
  }
  return (
    <div
      className={classNames(
        {
          'md:w-16': !isOpen,
          'bg-blue md:pb-6 top-0 left-0 z-50 w-full md:h-full': true,
          fixed: fixed,
          sticky: sticky
        },
        isOpen ? SidenavWidth : '',
        SidenavClassNames
      )}
    >
      <div className='md:text-center relative'>
        <div className='hidden md:inline-block my-6'>
          {isOpen ? (
            <Logo
              size='md'
              color='primary-on-dark'
              className='hidden md:block'
            />
          ) : (
            <Logo
              size='md'
              variant='isotype'
              color='primary-on-dark'
              className='hidden md:block'
            />
          )}
        </div>
        <div className='p-4 md:hidden h-16'>
          <Logo size='md' variant='isotype' color='primary-on-dark' />
        </div>
        <div className='absolute top-4 right-4'>
          <Button
            onClick={toggleMenu}
            type='button'
            color='default-on-dark'
            size='sm'
            icon={<IconMenu size='sm' />}
            className='md:hidden'
          />
        </div>
        <div className='hidden md:block pt-4 text-center mb-8'>
          {isOpen ? (
            <Avatar
              src={userInfo.avatar}
              name={userInfo.name}
              size='lg'
              type={badge}
            />
          ) : (
            <Avatar
              src={userInfo.avatar}
              name={userInfo.name}
              size='sm'
              type={badge}
            />
          )}

          <Text
            size='sm'
            className={classNames({
              'text-md p-2 text-white': true,
              hidden: !isOpen
            })}
          >
            {userInfo.name}
          </Text>
        </div>

        <div className='md:py-4 border-b border-gray-700'>
          <div className='hidden md:block absolute top-40 -right-4'>
            <Button
              onClick={(e) => {
                e?.preventDefault()
                HandleisOpen!()
              }}
              type='button'
              color='default-on-dark'
              size='sm'
              icon={
                isOpen ? (
                  <IconChevronLeft size='sm' />
                ) : (
                  <IconChevronRight size='sm' />
                )
              }
              className={classNames({
                'transition duration-500 ease-in-out transform': true,
                'hover:-translate-x-1': isOpen,
                'hover:translate-x-1': !isOpen
              })}
            />
          </div>
          <div
            className={classNames({
              'mt-0': isOpen,
              'mt-6': !isOpen,
              'md:block': true,
              block: menuIsOpen,
              hidden: !menuIsOpen
            })}
          >
            {paths.map((path, index) => {
              return (
                <Link
                  className={classNames({
                    'text-white flex px-4 py-2 no-underline hover:bg-primary_on_dark hover:text-gray-900 cursor-pointer transition duration-500 ease-in-out':
                      true,
                    'bg-primary_on_dark text-gray-900': path.selected,
                    [`${path?.className}`]: !!path?.className
                  })}
                  href={path.route}
                  download={false}
                  id={path.id}
                  size='md'
                  key={index}
                  target={path.target}
                  onClick={(e) => {
                    toggleMenu()
                    path.onClick && path.onClick(e)
                  }}
                >
                  <div className='p-2'>{path.icon}</div>
                  <div
                    className={classNames({
                      'text-md p-2': true,
                      'md:hidden': !isOpen
                    })}
                  >
                    {path.name}
                  </div>
                  {path.tag && <div className='p-2'>{path.tag}</div>}
                </Link>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
